<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useAccountSession } from '@/composables/useAccountSession'
const auth = useAuthStore()
const route = useRoute()
useAccountSession()
</script>

<template>
  <div v-if="auth.sessionNotice && !auth.isAuthenticated" class="alert alert--error session-notice" role="status">{{ auth.sessionNotice }}</div>
  <RouterView v-if="!route.meta.requiresAuth || auth.isAuthenticated" :key="auth.viewKey" />
</template>
<style scoped>.session-notice { margin: 12px auto; width: min(94%, 680px); }</style>
